import { RootState } from '@store/store';



export const selectAppMode = (state: RootState) => state.global.appMode;